export enum Color {
  Warn = 'warn',
  Primary = 'primary',
  Accent = 'accent',
  Default = 'default'
}
